<template>
	<el-tooltip
		placement="top"
		:content="statusTooltip"
		:open-delay="500"
		:disabled="!statusTooltip"
	>
		<div class="status_box" :class="{ pointer: withClick }" @click="click">
				<span :class="`progress_span ${spanClass}`"></span>
		</div>
	</el-tooltip>
</template>

<script>
export default {
	props: {
		statusCode: { type: String },
		statusTooltip: { type: String },
		withClick: { type: Boolean, default: false },
	},
	methods: {
		click() {
			this.$emit("click");
		},
	},
	computed: {
		spanClass() {
			let classString = this.statusCode === 'none' ? "has_border": "";
			return classString + ' progress_' + this.statusCode;
		}
	}
};
</script>

<style lang="scss" scoped>
.status_box {
	width: 40px;
	height: 40px;
	line-height: 40px;
	margin-right: 5px;
	display: flex;
	align-items: center;
	justify-content: center;


	.progress_span {
		display: inline-block;
		width: 25px;
		height: 25px;
		background-color: #bce1a3;
		vertical-align: center;
	}
	.progress_none {
		background-color: #ffffff;
	}
	.progress_gray {
		background-color: #E6E7E8;
	}
	.progress_green {
		background-color: #BCE1A3;
	}
	.progress_orange {
		background-color: #F6DA8F;
	}
	.progress_pink {
		background-color: #c71585;
	}
	.progress_icon {
		width: 25px;
		height: 25px;
		display: inline-block;
		line-height: 25px;
		text-align: center;
		vertical-align: center;

		i {
			font-size: 25px;
		}
	}
}
.has_border {
	border: 1px solid #c4c4c4;
}
</style>
